// src/admin/components/BannerTargetingSection.jsx

import { useTheme } from "../../context/ThemeContext";

export default function BannerTargetingSection({
    formData,
    updateField,
    categories = [],
    posts = [],
}) {

    const { isDark } = useTheme();

    const inputClass = `
        w-full
        px-4
        py-3
        rounded-2xl
        border
        outline-none
        transition-all
        ${
            isDark
                ? "bg-white/5 border-white/10 focus:border-blue-800/50"
                : "bg-white border-gray-300 focus:border-blue-800"
        }
    `;

    return (
        <section
            className={`
                rounded-3xl
                border
                p-8
                space-y-6
                ${
                    isDark
                        ? "border-white/10 bg-white/5"
                        : "border-gray-200 bg-white"
                }
            `}
        >
            <div>
                <h2 className="text-xl font-semibold">
                    Targeting
                </h2>

                <p className="opacity-70 mt-1">
                    Choose where this banner should appear.
                </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">

                <div>
                    <label className="block mb-2 font-medium">
                        Placement
                    </label>

                    <select
                        value={formData.placement}
                        onChange={(e) =>
                            updateField(
                                "placement",
                                e.target.value
                            )
                        }
                        className={inputClass}
                    >
                        <option value="">
                            Select placement
                        </option>

                        <option value="inline">
                            Inline
                        </option>

                        <option value="sidebar">
                            Sidebar
                        </option>

                        <option value="end_of_post">
                            End of Post
                        </option>
                    </select>
                </div>

                <div>
                    <label className="block mb-2 font-medium">
                        Category
                    </label>

                    <select
                        value={formData.category || ""}
                        onChange={(e) =>
                            updateField(
                                "category",
                                e.target.value || null
                            )
                        }
                        className={inputClass}
                    >
                        <option value="">
                            All Categories
                        </option>

                        {categories.map((category) => (
                            <option
                                key={category.id}
                                value={category.id}
                            >
                                {category.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="md:col-span-2">
                    <label className="block mb-2 font-medium">
                        Specific Blog Post
                    </label>

                    <select
                        value={formData.blog || ""}
                        onChange={(e) =>
                            updateField(
                                "blog",
                                e.target.value || null
                            )
                        }
                        className={inputClass}
                    >
                        <option value="">
                            All Blog Posts
                        </option>

                        {posts.map((post) => (
                            <option
                                key={post.id}
                                value={post.id}
                            >
                                {post.title}
                            </option>
                        ))}
                    </select>

                    <p className="text-sm opacity-60 mt-2">
                        Leave empty to show the banner on all blog posts
                        that match the selected placement.
                    </p>
                </div>

             

          

                <div>
                    <label className="block mb-2 font-medium">
                        Priority
                    </label>

                    <input
                        type="number"
                        min="1"
                        value={formData.priority}
                        onChange={(e) =>
                            updateField(
                                "priority",
                                e.target.value
                            )
                        }
                        className={inputClass}
                    />
                </div>

              

            </div>
        </section>
    );
}